import { type_of_use_enum } from '../generated/enums';

export enum orientation_enum {
  NORTH = 'NORTH',
  NORTH_EAST = 'NORTH_EAST',
  EAST = 'EAST',
  SOUTH_EAST = 'SOUTH_EAST',
  SOUTH = 'SOUTH',
  SOUTH_WEST = 'SOUTH_WEST',
  WEST = 'WEST',
  NORTH_WEST = 'NORTH_WEST',
  HORIZONTAL = 'HORIZONTAL',
}

// Export-related enums
export enum export_entity_type_enum {
  BUILDING = 'BUILDING',
  SCENARIO = 'SCENARIO',
  ACTION_PLAN = 'ACTION_PLAN',
}

export enum export_format_enum {
  EXCEL = 'EXCEL',
  PDF = 'PDF',
}

/**
 * This enum actually come from hasura..
 * If its not referenced by a fk_relationship its not generated though (why?)
 * So for now we manually declare it here
 */
export enum roof_type_enum {
  FLAT_ROOF = 'FLAT_ROOF',
  GABLE_ROOF = 'GABLE_ROOF',
  SHED_ROOF = 'SHED_ROOF',
}

export enum sustainaccount_climate_risk_hazard_enum {
  CHANGING_RAIN_PATTERNS = 'changingRainPatterns',
  CHANGING_TEMPERATURE_AIR = 'changingTemperatureAir',
  CHANGING_WIND_PATTERNS = 'changingWindPatterns',
  COASTAL_FLOOD = 'coastalFlood',
  COASTAL_EROSION = 'coastalErosion',
  COLD_WAVE = 'coldWave',
  DROUGHT = 'drought',
  FROST = 'frost',
  GROUND_WATER_FLOOD = 'groundWaterFlood',
  HEAT_STRESS = 'heatStress',
  HEAT_WAVE = 'heatWave',
  HEAVY_HAIL = 'heavyHail',
  HEAVY_RAIN = 'heavyRain',
  PERMAFROST_THAWING = 'permafrostThawing',
  RIVER_FLOOD = 'riverFlood',
  SEA_LEVEL_RISE = 'seaLevelRise',
  SNOW_STORM = 'snowStorm',
  SOIL_EROSION = 'soilErosion',
  SUBSIDENCE = 'subsidence',
  TORNADO = 'tornado',
  WILDFIRE = 'wildfire',
  WINTER_STORM = 'winterStorm',

  // unused ones
  AIR_QUALITY = 'airQuality',
  EARTHQUAKE = 'earthquake',
  LIGHTNING_STRIKE = 'lightningStrike',
  NOISE = 'noise',
  RADON = 'radon',

  // non sustainable climate risks
  TEMPERATURE_VARIABILITY = 'temperatureVariability',
  CYCLONE_HURRICANE_TYPHOON = 'cycloneHurricaneTyphoon',
  PRECIPITATION_HYDROLOGICAL_VARIABILITY = 'precipitationHydrologicalVariability',
  OCEAN_ACIDIFICATION = 'oceanAcidification',
  SALINE_INTRUSION = 'salineIntrusion',
  WATER_STRESS = 'waterStress',
  SOIL_DEGRADATION = 'soilDegradation',
  SOLIFLUCTION = 'solifluction',
  AVALANCHE = 'avalanche',
  LANDSLIDE = 'landslide',
  GLACIAL_LAKE_OUTBURST = 'glacialLakeOutburst',
}

export enum sustainaccount_climate_risk_scenario_enum {
  RCP_2_6 = 'RCP 2.6',
  RCP_4_5 = 'RCP 4.5',
  RCP_8_5 = 'RCP 8.5',
}

export enum sustainaccount_climate_risk_framework_enum {
  BASIC = 'basic',
  EU_TAXONOMY = 'eu_taxonomy',
  DGNB18 = 'dgnb18',
  DGNB23 = 'dgnb23',
}

export enum sustainaccount_climate_risk_severity_enum {
  VERY_LOW = 'veryLow',
  LOW = 'low',
  MEDIUM = 'moderate',
  HIGH = 'high',
  VERY_HIGH = 'veryHigh',
}

export enum unit_enum {
  CENTIGRADE = 'CENTIGRADE',
  CENTIMETERS = 'CENTIMETERS',
  CUBIC_METERS = 'CUBIC_METERS',
  CUBIC_METERS_PER_SQM = 'CUBIC_METERS_PER_SQM',
  DAYS = 'DAYS',
  DEGREES = 'DEGREES',
  EURO = 'EURO',
  EURO_PER_KWH = 'EURO_PER_KWH',
  EURO_PER_TON_CO2_PER_YEAR = 'EURO_PER_TON_CO2_PER_YEAR',
  EURO_PER_KW_PEAK = 'EURO_PER_KW_PEAK',
  EURO_PER_SQM = 'EURO_PER_SQM',
  EURO_PER_SQM_PER_YEAR = 'EURO_PER_SQM_PER_YEAR',
  EURO_PER_YEAR = 'EURO_PER_YEAR',
  G_CO2E = 'G_CO2E',
  G_CO2E_PER_EURO_PER_YEAR = 'G_CO2E_PER_EURO_PER_YEAR',
  G_CO2E_PER_KWH = 'G_CO2E_PER_KWH',
  KILOGRAM = 'KILOGRAM',
  KG_CO2E = 'KG_CO2E',
  KG_CO2E_PER_KWH = 'KG_CO2E_PER_KWH',
  KG_CO2E_PER_MWH = 'KG_CO2E_PER_MWH',
  KG_CO2E_PER_SQM = 'KG_CO2E_PER_SQM',
  KG_CO2E_PER_SQM_PER_YEAR = 'KG_CO2E_PER_SQM_PER_YEAR',
  KG_CO2E_PER_YEAR = 'KG_CO2E_PER_YEAR',
  KILOGRAM_PER_SQM = 'KILOGRAM_PER_SQM',
  KWH = 'KWH',
  KWH_PER_SQM = 'KWH_PER_SQM',
  KWH_PER_SQM_PER_YEAR = 'KWH_PER_SQM_PER_YEAR',
  KWH_PER_YEAR = 'KWH_PER_YEAR',
  KW_PEAK = 'KW_PEAK',
  LUMENS = 'LUMENS',
  LUMENS_PER_WATT = 'LUMENS_PER_WATT',
  MWH = 'MWH',
  METERS = 'METERS',
  PERCENTAGE = 'PERCENTAGE',
  SQM = 'SQM',
  SQM_PER_YEAR = 'SQM_PER_YEAR',
  TIMES = 'TIMES',
  TONS = 'TONS',
  TONS_PER_SQM = 'TONS_PER_SQM',
  TONS_CO2E = 'TONS_CO2E',
  WATT = 'WATT',
  WATT_PER_M_PER_KELVIN = 'WATT_PER_M_PER_KELVIN',
  WATT_PER_SQM_PER_KELVIN = 'WATT_PER_SQM_PER_KELVIN',
  WATT_PEAK_SQM = 'WATT_PEAK_SQM',
  YEAR = 'YEAR',
}

export enum solar_module_technology_enum {
  POLY_CRYSTALLINE = 'Polykristallin',
  HIGH_EFFICIENCY_MODULES = 'Hocheffizienzmodule',
  MONO_CRYSTALLINE = 'Monokristallin',
  CIS_CIGS = 'CIS / CIGS',
}

// Export-specific async job names
/*
 !! IMPORTANT !!
 Please use this naming convention: 
 ExportEntityType_ExportFormat_EXPORT
 e.g: if you are exporting a building as excel, the job name should be BUILDING_EXCEL_EXPORT
*/
export enum export_jobs_enum {
  BUILDING_EXCEL_EXPORT = 'BUILDING_EXCEL_EXPORT',
  SCENARIO_EXCEL_EXPORT = 'SCENARIO_EXCEL_EXPORT',
  ESG_ANALYSIS_PDF_EXPORT = 'ESG_ANALYSIS_PDF_EXPORT',
  ECONOMIC_UNIT_ESG_ANALYSIS_PDF_EXPORT = 'ECONOMIC_UNIT_ESG_ANALYSIS_PDF_EXPORT',
  ACTION_PLAN_PDF_EXPORT = 'ACTION_PLAN_PDF_EXPORT',
  REPORT_PDF_EXPORT = 'REPORT_PDF_EXPORT',
  SUMMARY_ONE_PAGER_PDF_EXPORT = 'SUMMARY_ONE_PAGER_PDF_EXPORT',
  BATCH_ESG_ANALYSIS_PDF_EXPORT = 'BATCH_ESG_ANALYSIS_PDF_EXPORT',
}

export enum district_heating_availability_enum {
  UNKNOWN = 'UNKNOWN',
  PLANNED = 'PLANNED',
  UNPLANNED = 'UNPLANNED',
  AVAILABLE = 'AVAILABLE',
}

export enum type_of_use_category_enum {
  ACCOMMODATION_AND_CATERING = 'ACCOMMODATION_AND_CATERING',
  CARE = 'CARE',
  ADMINISTRATION = 'ADMINISTRATION',
  RESEARCH = 'RESEARCH',
  PRODUCTION_AND_OPERATIONS = 'PRODUCTION_AND_OPERATIONS',
  TECHNICAL_INFRASTRUCTURE = 'TECHNICAL_INFRASTRUCTURE',
  HEALTHCARE = 'HEALTHCARE',
  CULTURE_AND_LEISURE = 'CULTURE_AND_LEISURE',
  RETAIL = 'RETAIL',
  TRANSPORT = 'TRANSPORT',
  SPORTS = 'SPORTS',
  RESIDENTIAL = 'RESIDENTIAL',
}

export enum crrem_type_of_use_enum {
  OFFICE = 'Office',
  RETAIL = 'Retail, High Street',
  SHOPPING_CENTER = 'Retail, Shopping Center',
  RETAIL_WAREHOUSE = 'Retail, Warehouse',
  DISTRIBUTION_WAREHOUSE_COLD = 'Industrial, Distribution Warehouse Cooled',
  DISTRIBUTION_WAREHOUSE_WARM = 'Industrial, Distribution Warehouse',
  HOTEL = 'Hotel',
  HEALTH_FACILITY = 'Healthcare',
  LODGING_LEISURE_RECREATION = 'Lodging, Leisure & Recreation',
  MFH = 'Residential Multi-Family',
}

export type crrem_type_with_sfh_enum = type_of_use_enum.SFH | crrem_type_of_use_enum;

export enum scaling_constraint_range_enum {
  IN_RANGE = 'in_range',
  OUT_OF_RANGE = 'out_of_range',
}

export enum building_model_type_enum {
  TWIN = 'TWIN',
  ACTIVE = 'ACTIVE',
  INACTIVE_DRAFT = 'INACTIVE_DRAFT',
}

// Values of the consumption overview row status (getConsumptionOverview; no enum table backing it)
export enum status_consumption_enum {
  ACTIVE = 'ACTIVE',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  PROCESSING = 'PROCESSING',
  FAILED = 'FAILED',
  DUPLICATED = 'DUPLICATED',
  INACTIVE = 'INACTIVE',
}

// Values of the consumption overview row source (consumption_source_type_enum minus API_ENTRY, METER_READING surfaced as SMART_METER)
export enum source_consumption_enum {
  MANUAL_ENTRY = 'MANUAL_ENTRY',
  ESTIMATION = 'ESTIMATION',
  SMART_METER = 'SMART_METER',
  INVOICE = 'INVOICE',
}
